import Link from 'next/link'

import { Container } from '@/components/Container'
import { FadeIn } from '@/components/FadeIn'
import { Logo } from '@/components/Logo'
import { Offices } from '@/components/Offices'
import { socialMediaProfiles } from '@/components/SocialMedia'
import { TrackedLink } from '@/components/TrackedLink'
import Image from 'next/image'
import htwgLogo from '@/images/htwg-logo.png'
import bwLogo from '@/images/logo-m-mwk_de.svg'
import stadtKonstanzLogo from '@/images/logo-konstanz.svg'
import theLaend from '@/images/thelaend_part_of_shape_color.svg'

const navigation = [
  // {
  //   title: 'Use Cases',
  //   links: [
  //     { title: 'thepalia X Health-Apps', href: '/use-cases/health-apps' },
  //     {
  //       title: 'thepalia X Health-Experts',
  //       href: '/use-cases/health-experts',
  //     },
  //     {
  //       title: 'thepalia X Gesundheitszentren',
  //       href: '/use-cases/gesundheitszentren',
  //     },
  //     {
  //       title: 'thepalia X Fitnessstudios',
  //       href: '/use-cases/fitnessstudios',
  //     },
  //     { title: 'thepalia X Yoga-Studios', href: '/use-cases/yoga-studios' },
  //   ],
  // },
  {
    title: 'Menü',
    links: [
      { title: 'Home', href: '/' },
      { title: 'Über uns', href: '/about' },
      { title: 'Infrastruktur', href: '/infrastructure' },
      { title: 'Insights', href: '/insights' },
      { title: 'Kontakt', href: '/contact' },
      {
        title: 'Jobs',
        href: 'https://thepalia.getoutline.com/s/hire',
      },
    ],
  },

  {
    title: 'Folge uns',
    links: socialMediaProfiles,
  },
]

function Navigation() {
  return (
    <nav>
      <ul role="list" className="grid grid-cols-2 gap-8">
        {navigation.map((section, sectionIndex) => (
          <li key={sectionIndex}>
            <div className="font-display text-sm font-semibold tracking-wider text-zinc-950">
              {section.title}
            </div>
            <ul role="list" className="mt-4 text-sm text-zinc-700">
              {section.links.map((link, linkIndex) => (
                <li key={linkIndex} className="mt-4">
                  {link.href === '/contact' ? (
                    <TrackedLink
                      href={link.href}
                      className="transition hover:text-zinc-950"
                      event="cta_contact"
                      eventData={{ location: 'footer' }}
                    >
                      {link.title}
                    </TrackedLink>
                  ) : link.href.startsWith('http') ? (
                    <TrackedLink
                      href={link.href}
                      className="transition hover:text-zinc-950"
                      event="outbound"
                      eventData={{
                        destination: link.title.toLowerCase(),
                        type: 'jobs',
                      }}
                    >
                      {link.title}
                    </TrackedLink>
                  ) : (
                    <Link
                      href={link.href}
                      className="transition hover:text-zinc-950"
                    >
                      {link.title}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </nav>
  )
}

function ArrowIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg viewBox="0 0 16 6" aria-hidden="true" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 3 10 .5v2H0v1h10v2L16 3Z"
      />
    </svg>
  )
}

function FooterOffice() {
  return (
    <div>
      <h2 className="font-display text-sm font-semibold tracking-wider text-zinc-950">
        Unser Office
      </h2>
      <Offices className="mt-4" />
    </div>
  )
}

function FooterDescription() {
  return (
    <div className="max-w-sm">
      <h2 className="font-display text-sm font-semibold tracking-wider text-zinc-950">
        thepalia GmbH
      </h2>
      <p className="mt-4 text-sm text-zinc-700">
        Nutze die thepalia Präventionsinfrastruktur. Die All-in-One Lösung, um
        digitale Präventionskurse zertifizieren und betreiben zu lassen. Wir
        stellen die Technik und sichern die § 20 SGB V Zulassung, damit die
        Krankenkasse zahlt und dein Unternehmen planbar wächst.
      </p>
      <div className="relative mt-6 flex gap-x-4 text-sm text-zinc-500 underline">
        <Link href="/impressum" className="hover:text-zinc-950">
          Impressum
        </Link>
        <Link href="/datenschutz" className="hover:text-zinc-950">
          Datenschutz
        </Link>
      </div>
    </div>
  )
}

export function Footer() {
  return (
    <Container as="footer" className="mt-24 w-full sm:mt-32 lg:mt-40">
      <FadeIn>
        <div className="grid grid-cols-1 gap-x-8 gap-y-16 sm:grid-cols-2 lg:grid-cols-3">
          <Navigation />
          <FooterOffice />
          <div className="flex sm:justify-end lg:justify-end">
            <FooterDescription />
          </div>
        </div>
        <div className="mt-24 text-sm text-zinc-700">
          <div className="mb-6 text-sm font-medium text-zinc-500">
            Unterstützt von:
          </div>
          <div className="flex flex-wrap items-center justify-start gap-8 rounded-2xl px-4 py-6 sm:justify-between">
            <div className="flex flex-col items-center">
              <Image
                src={htwgLogo}
                alt="HTWG Konstanz"
                width={240}
                height={240}
                className="h-16 w-auto"
                style={{ objectFit: 'contain' }}
              />
            </div>
            <div className="flex flex-col items-center">
              <Image
                src={bwLogo}
                alt="Land Baden-Württemberg"
                width={80}
                height={80}
                className="h-16 w-auto"
                style={{ objectFit: 'contain' }}
              />
            </div>
            <div className="flex flex-col items-center">
              <Image
                src={stadtKonstanzLogo}
                alt="Stadt Konstanz"
                width={80}
                height={80}
                className="h-16 w-auto"
                style={{ objectFit: 'contain' }}
              />
            </div>
          </div>
        </div>
        <div className="mt-24 mb-20 flex flex-col items-center justify-center gap-x-6 gap-y-12 border-t border-zinc-950/10 pt-12 sm:flex-row sm:items-end sm:justify-between">
          <Image
            src={theLaend}
            alt="theLaend"
            width={120}
            height={120}
            className="h-20"
          />

          <Link href="/" aria-label="Home">
            <Logo className="h-4" fillOnHover />
          </Link>
          <p className="text-sm text-zinc-700">
            © thepalia GmbH {new Date().getFullYear()}
          </p>
        </div>

        <div className="mx-auto mb-4 text-center font-display text-sm text-zinc-700">
          Made with 🫀 in Konstanz.
        </div>
      </FadeIn>
    </Container>
  )
}
